import { svg } from 'lit';

const symbol = svg`<svg width="16" height="12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M.703 5.96l4.7 4.8 9.9-9.9" stroke="#fff"/></svg>`;

export { symbol as default };
